import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * STD Test Forms
   */
  {
    // 1
    label: "What's your age?",
    field: 'stdAge',
    type: 'info',
    answer: {
      type: 'number',
      name: 'age',
      min: 18,
      max: 100,
      placeholder: 'Please type here...'
    }
  },
  {
    // 2
    label: 'What gender do you identify as?',
    field: 'stdGender',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'male',
          value: 'Male'
        },
        {
          key: 'female',
          value: 'Female'
        }
      ]
    }
  },
  {
    // 3
    field: 'stdExperience',
    type: 'info',
    label: 'Are you experiencing any of the following?',
    answer: {
      type: 'branch',
      items: [
        {
          condition: { key: 'stdGender.male', operator: 'eq', value: true },
          answer: {
            type: 'multi_select',
            options: [
              {
                key: 'unusualDischarge',
                value:
                  'unusual (discolored) discharge with an odour from the penis'
              },
              {
                key: 'rash',
                value: 'a rash, sores or itching on or around the genitals'
              },
              {
                key: 'burning',
                value: 'burning or discomfort during urination'
              },
              { key: 'painAbdomen', value: 'pain in the lower abdomen' },
              { key: 'painSex', value: 'pain during sex or masturbation' },
              { key: 'bleeding', value: 'bleeding from the penis' }
            ]
          }
        },
        {
          condition: { key: 'stdGender.female', operator: 'eq', value: true },
          answer: {
            type: 'multi_select',
            options: [
              {
                key: 'unusualDischarge1',
                value:
                  'unusual discharge (different colour, smell or amount) from the vagina'
              },
              {
                key: 'rash1',
                value: 'a rash, sores or itching on or around the genitals'
              },
              {
                key: 'excessive1',
                value: 'excessive itching in the vagina or labia'
              },
              {
                key: 'burning1',
                value: 'burning or discomfort during urination'
              },
              { key: 'painAbdomen1', value: 'pain in the lower abdomen' },
              {
                key: 'bleeding1',
                value:
                  'bleeding from the vagina other than during a monthly period'
              },
              { key: 'painSex1', value: 'pain during sex or masturbation' }
            ]
          }
        }
      ]
    }
  },
  {
    // 4
    field: 'stdUnprotected',
    type: 'info',
    label: '',
    answer: {
      type: 'branch',
      items: [
        {
          condition: { key: 'stdGender.male', operator: 'eq', value: true },
          answer: {
            label:
              'Have you had unprotected sex? Examples include: not using a condom, not using a condom correctly and/or consistently, if a condom broke during sexual activity. ',
            type: 'text',
            level: 'top',
            name: 'unprotectedSexMale',
            placeholder: 'Please type here...'
          }
        },
        {
          condition: { key: 'stdGender.female', operator: 'eq', value: true },
          answer: {
            type: 'list',
            items: [
              {
                label:
                  'Have you had unprotected sex? Examples include: not using a condom, not using a condom correctly and/or consistently, if a condom broke during sexual activity. ',
                type: 'text',
                level: 'top',
                name: 'unprotectedSexFemale',
                placeholder: 'Please type here...'
              },
              {
                label: 'Is there a chance you might be pregnant?',
                type: 'single_select',
                name: 'pregnant',
                options: [
                  {
                    key: 'pregnantYes',
                    value: 'Yes',
                    answer: {
                      label: 'Are you Breastfeeding?',
                      type: 'radio',
                      name: 'breastfeedingOption',
                      options: [
                        { key: 'breastYes', value: 'Yes' },
                        { key: 'breastNo', value: 'No' }
                      ]
                    }
                  },
                  { key: 'pregnantNo', value: 'No' },
                  { key: 'pregnantUnknown', value: 'Unknown' }
                ]
              }
            ]
          }
        }
      ]
    }
  }
];

export default questionsModels;
